import React, { useEffect, useState, useContext } from 'react';
import { SVBTypography, SVBButton } from '@svb/svb-react-components';
import { detailsContext } from './context/DetailsProvider';
import { Link } from 'react-router-dom';
import { fetchFileData } from '../../helpers/fetchDatafromContentSVC';

function SolutionDetailsGettingStarted({ children, title, ...props }) {
  const { addTitle, idGenerator } = useContext(detailsContext);
  const [fileData, setFileData] = useState(null);
  let contentURL = props?.url;
  let solutionType = props?.solType;
  let postmanCollection = props?.postman;

  const handleDownloadClick = async () => {
    const data = await fetchFileData(
      `${contentURL}?resourcePath=solutions/${solutionType}/resources&resourceName=${postmanCollection}.json`,
    );
    setFileData(data);
  };

  useEffect(() => {
    addTitle(title);
    handleDownloadClick();
  }, [title]);
  return (
    <section className='getting-started-section-content' id={idGenerator(title)}>
      <div className='getting-started-section-content-block'>
        <SVBTypography type='heading-large' variant='mb-4'>
          {title}
        </SVBTypography>
        <div className='paragraph'>{children}</div>
      </div>
      {postmanCollection === undefined ? (
        ''
      ) : (
        <div className='getting-started-section-content-block'>
          <SVBTypography type='heading-medium' variant='semi-bold'>
            Postman Collection
          </SVBTypography>
          <SVBTypography type='paragraph'>
            The Postman Collection provides a pre-configured example of each API required to build
            the solution described above.
          </SVBTypography>
          {fileData && (
            <Link
              to={URL.createObjectURL(fileData)}
              target='_blank'
              download={`${postmanCollection}.json`}
            >
              <SVBButton
                extraClasses='m-1'
                text='Download Collection'
                size='large'
                style='primary'
                state='default'
                type='text'
                icon='download-white.svg'
                iconSide='left'
                // leftIconExtraClasses='pe-2'
                onClick={() => {}}
              />
            </Link>
          )}
        </div>
      )}
    </section>
  );
}

export default SolutionDetailsGettingStarted;
